export default {
  dashboard: {
    blocks: "区块",
    sevenDays: "7天",
    topTenBlockProducers: "前十名BP节点",
    topTenDappsProducers: "前十名 Dapps 制作者",
    transactions: "交易",
    transactionVolume: "交易数量"
  }
}
